import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { BUTTON_VARIANTS, Button, ButtonProps } from 'ui/button';
import { Add16 } from 'ui/icons';
import { colors } from 'ui/theme';

const StyledAdd16 = styled(Add16)`
  path {
    stroke: ${colors.textSecondary};
    fill: ${colors.textSecondary};
  }
`;

const AddItemButton = ({ children, ...props }: PropsWithChildren<ButtonProps>) => (
  <Button variant={BUTTON_VARIANTS.SECONDARY} {...props}>
    <StyledAdd16 />
    {children}
  </Button>
);

export default AddItemButton;
